import { create } from 'zustand';
import { PackageType } from 'typings/wallet.type';
import {
  deletePackageAction,
  getBasketDataAction,
  getProductsDataAction,
  postAddPackageToBasketAction,
  getCheckoutAction,
  putBasketDataAction,
} from './action';
import { BasketType } from 'typings/profile.type';

type ProductsType = {
  getProductsDataAction: () => Promise<PackageType[]>;
  postAddPackageToBasketAction: (selectedPackage: PackageType) => Promise<void>;
  deletePackageAction: (id: string, isSimple: boolean) => Promise<void>;
  getBasketDataAction: (couponCode?: string) => Promise<void>;
  putBasketDataAction: () => Promise<void>;
  getCheckoutAction: (couponCode?: string) => Promise<string>;
  basketLoading: boolean;
  basketError: boolean;
  checkoutLoading: boolean;
  deletePackageLoading: string;
  userCouponCode: string;
  productsData: PackageType;
  basketData: BasketType;
  productsLoading: boolean;
  banner: string;
  productsError: boolean;
  putBasketLoading: boolean;
  reset: () => void;
};

const initialState = {
  productsData: null,
  basketData: null,
  banner: null,
  productsLoading: false,
  productsError: false,
  basketLoading: false,
  putBasketLoading: false,
  basketError: false,
  checkoutLoading: false,
  userCouponCode: '',
  deletePackageLoading: null,
};

const useWalletStore = create<ProductsType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),

  getProductsDataAction: async (): Promise<PackageType[]> =>
    getProductsDataAction(set),
  postAddPackageToBasketAction: async (
    selectedPackage: PackageType,
  ): Promise<void> => postAddPackageToBasketAction(set, selectedPackage),

  deletePackageAction: async (id: string, isSimple: boolean): Promise<void> =>
    deletePackageAction(set, id, isSimple),

  getBasketDataAction: async (couponCode?: string): Promise<void> =>
    getBasketDataAction(set, couponCode),

  putBasketDataAction: async (): Promise<void> => putBasketDataAction(set),

  getCheckoutAction: async (couponCode?: string): Promise<string> =>
    getCheckoutAction(set, couponCode),
}));

export default useWalletStore;
